module.exports = __webpack_public_path__ + "media/images/gallery/dn_on-bb07936e856f90e4a05d248f02ccaa85.gif";